import { useRef } from 'react';
import { casinoRouteForLobby } from '../../data/casinoData';
import { useLocale } from '../../context';
import { HOME_PROVIDERS } from './homeProvidersData';
import './homeProviders.css';

const ALL_GAMES_TAB_ID = '496';

const LIVE_HINTS = ['evolution', 'ezugi', 'pragmaticplaylive', 'live', 'onair', 'realdealer'];
const FAST_HINTS = ['smartsoft', 'spribe', 'galaxsys', 'aviatrix'];

function lobbyForProvider(provider = {}) {
  const key = `${provider.slug || ''} ${provider.title || ''}`.toLowerCase().replace(/[\s_-]+/g, '');
  if (LIVE_HINTS.some((h) => key.includes(h))) return 'live';
  if (FAST_HINTS.some((h) => key.includes(h))) return 'fast';
  return 'slots';
}

const PLAY_SVG = (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M19.902 40c10.991 0 19.902-8.954 19.902-20S30.894 0 19.902 0 0 8.954 0 20s8.91 20 19.902 20Z"
      fill="currentColor"
    />
    <path
      d="m28.947 18.606-12.4-7.365a1.676 1.676 0 0 0-2.323.606c-.15.26-.226.556-.224.856V27.43a1.704 1.704 0 0 0 .852 1.474 1.682 1.682 0 0 0 1.695-.012l12.398-7.36a1.693 1.693 0 0 0 .834-1.462 1.703 1.703 0 0 0-.832-1.464Z"
      fill="#fff"
    />
  </svg>
);

function logoSrc(path) {
  if (!path) return path;
  return path.includes('?') ? path : `${path}?v=6`;
}

export default function HomeProviders({ onNavigate }) {
  const { t } = useLocale();
  const scrollerRef = useRef(null);
  const providers = HOME_PROVIDERS;
  if (!providers?.length) return null;

  const scrollBy = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * Math.min(560, el.clientWidth * 0.8), behavior: 'smooth' });
  };

  const openProvider = (provider) => {
    if (!onNavigate) return;
    const lobby = lobbyForProvider(provider);
    const route = casinoRouteForLobby(lobby);
    onNavigate('casino', {
      casinoTabId: ALL_GAMES_TAB_ID,
      casinoLobbyId: route.casinoLobbyId,
      casinoProvider: provider.title,
    });
  };

  return (
    <section className="home-providers" aria-label={t('casino.topProviders')}>
      <div className="home-providers__head">
        <h2 className="home-providers__title">{t('casino.topProviders')}</h2>
        <div className="home-providers__nav">
          <button type="button" className="home-providers__arrow" aria-label="Prev" onClick={() => scrollBy(-1)}>
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
          <button type="button" className="home-providers__arrow" aria-label="Next" onClick={() => scrollBy(1)}>
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
        </div>
      </div>
      <ul className="home-providers__list" ref={scrollerRef}>
        {providers.map((provider) => (
          <li key={provider.slug} className="home-providers__item">
            <a
              href="/tr/casino"
              className="home-providers__card"
              title={provider.title}
              onClick={(e) => {
                e.preventDefault();
                openProvider(provider);
              }}
            >
              <div className="home-providers__tile">
                <img
                  className="home-providers__logo"
                  src={logoSrc(provider.logo)}
                  alt={provider.title}
                  width={180}
                  height={50}
                  loading="lazy"
                  decoding="async"
                />
                <div className="home-providers__overlay" aria-hidden="true">
                  <div className="home-providers__play-wrap">
                    <div className="home-providers__play">{PLAY_SVG}</div>
                  </div>
                </div>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
